export const iconMap: Record<number, string> = {
  1: "fas fa-box-open",        // Hazır Markalar (Desktop)
  2: "fas fa-microchip",       // Anakart
  3: "fas fa-microchip",       // İşlemci
  4: "fas fa-memory",          // RAM
  5: "fas fa-tv",              // Ekran Kartı
  6: "fas fa-hdd",             // HDD
  7: "fas fa-bolt",            // SSD
  8: "fas fa-plug",            // Güç Kaynağı
  9: "fas fa-desktop",         // Bilgisayar Kasası
  10: "fas fa-layer-group",    // Adetli Satış
  11: "fas fa-laptop",         // Hazır Markalar (Laptop)
  12: "fas fa-screwdriver-wrench", // Yedek Parçalar
  13: "fas fa-headphones",     // Aksesuarlar
  14: "fas fa-headset",        // Kulaklık ve Mikrofon
  15: "fas fa-computer-mouse", // Mouse
  16: "fas fa-keyboard",       // Klavye
  17: "fas fa-hdd",            // Harici HDD
  18: "fas fa-bolt",           // Harici SSD
  19: "fas fa-usb",            // USB Bellek
  20: "fas fa-display",        // Oyuncu Monitörü
  21: "fas fa-display",        // Ofis Monitörü
  22: "fas fa-display",        // Tasarım Monitörü
  23: "fas fa-gamepad",        // Oyun Konsolları
  24: "fas fa-toolbox",        // Bilgisayar Ekipmanları
  25: "fas fa-server",         // Sunucu
};

// These can be added to the backend in a future update, to avoid re-migration it is now added here. The keys are product type IDs, and the values are the corresponding FontAwesome icon class names.